<template>
  <v-card
    flat
    class="custom-field"
    :class="{ 'custom-field--dark': $vuetify.theme.dark }">
    <!-- HEADER -->
    <div class="custom-field__header">
      <span class="custom-field__title">
        Custom {{ fieldIndex }}
      </span>
      <v-switch
        v-model="localEnabled"
        disabled
        hide-details
      />
    </div>
    <!-- BODY -->
    <div class="custom-field__body">
      <v-text-field
        v-model="localValue.title"
        :label="label"
        dense
        outlined
        hide-details
        disabled
      />
      <v-text-field
        v-model="localValue.content"
        label="Content"
        dense
        outlined
        :disabled="!localEnabled"
        :error-messages="errorMessages"
        @input="updateValue"
      />
    </div>

  </v-card>
</template>

<script>
export default {
  name: "CustomFieldRow",

  props: {
    value: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: "Custom field"
    },
    fieldIndex: {
      type: Number,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    unique: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      localValue: { title: this.value.title || '', content: this.value.content || '' }
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.localValue = { title: newVal.title || '', content: newVal.content || '' };
      },
      deep: true
    }
  },
  mounted() {
    this.updateValue();
  },
  methods: {
    updateValue() {
      this.$emit('input', { title: this.localValue.title, content: this.localValue.content, enabled: this.localEnabled });
    }
  },

  computed: {
    localEnabled: {
      get() {
        return this.value.enabled
      },
      set(val) {
        this.$emit("input", {
          title: this.localValue.title,
          content: this.localValue.content,
          enabled: val
        })
      }
    }
  }
}
</script>

<style scoped>
.custom-field {
  border-radius: 8px;
  padding: 16px;
  background-color: #f5f5f5;
}

.custom-field--dark {
  background-color: #2f3338;
}

/* Header */
.custom-field__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.custom-field__title {
  font-size: 14px;
  font-weight: 500;
}

/* Body */
.custom-field__body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
</style>
